import { getBootstrapped } from "core-integration/src/store/bootstrap/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import { setAuthFlowActive } from "../../providers/D3AuthProvider";
import Alert from "../Alert";
import { Loading } from "../App";

const LoggedIn: React.FC = () => {
  const player = useSelector(getPlayerData);
  const bootstrapped = useSelector(getBootstrapped);
  const [timeoutReached, setTimeoutReached] = useState(false);

  useEffect(() => {
    // Keep auth flow active during logged-in page - we're still in initial auth
    setAuthFlowActive(true);

    // Set a timeout to detect if bootstrap is taking too long
    const timeout = setTimeout(() => {
      setTimeoutReached(true);
    }, 10000); // 10 second timeout

    return () => {
      clearTimeout(timeout);
      // Clear auth flow flag when we navigate away (auth complete or failed)
      setAuthFlowActive(false);
    };
  }, []);

  // If bootstrap is taking too long, show timeout message
  if (timeoutReached && !bootstrapped) {
    return (
      <div style={{ padding: "2rem", maxWidth: "600px", margin: "0 auto" }}>
        <Alert type="error">
          <strong>Loading Timeout</strong>
          <p>
            Your profile is taking longer than expected to load. This might be
            due to a slow connection or server issue.
          </p>
          <p>Please try refreshing the page or logging in again.</p>
        </Alert>
        <a
          href="/"
          style={{
            display: "inline-block",
            marginTop: "1rem",
            color: "#007bff",
            textDecoration: "none",
          }}
        >
          Return to homepage
        </a>
      </div>
    );
  }

  // Wait for bootstrap to complete before deciding where to redirect
  if (!bootstrapped) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <Loading />
        <p style={{ marginTop: "1rem" }}>Loading your profile...</p>
      </div>
    );
  }

  // Bootstrap complete - now decide where to redirect
  if (!player) {
    return <Navigate to="/" />;
  } else if (!player.entry) {
    return <Navigate to="/squad-selection" />;
  }
  return <Navigate to="/my-team" />;
};

export default LoggedIn;
